var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSyncUsuario(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 394,
    height: 394,
    viewBox: "0 0 394 394",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.7 0H314.8C358.3 0 393.5 35.2 393.5 78.7V314.8C393.5 358.3 358.3 393.5 314.8 393.5H78.7C35.2 393.5 0 358.3 0 314.8V78.7C0 35.3 35.2 0 78.7 0Z",
    fill: "#FAFAFA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_657_15)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M185.57 61.3588C173.424 62.8764 164.134 64.874 155.005 67.9327C110.191 82.9446 75.7713 120.402 64.6627 166.25C61.9884 177.287 61.3499 182.578 61.0645 196.081C60.77 209.98 61.4435 217.727 63.9243 228.974C65.0948 234.284 68.1338 244.814 68.6595 245.383C68.7589 245.491 73.409 243.961 78.9931 241.983C87.3142 239.036 89.0859 238.234 88.8159 237.535C86.9442 232.692 84.2444 220.718 83.2302 212.762C82.3994 206.244 82.5541 190.787 83.5204 183.791C90.022 136.719 123.732 98.6565 169.889 86.2706C186.768 81.7411 208.378 81.5317 225.969 85.7262C238.887 88.8067 252.861 94.824 263.172 101.745L265.822 103.525H253.736H241.65V114.156V124.788H273.544H305.438V92.8939V61H294.807H284.175V75.4171V89.8342L282.979 88.9698C270.337 79.837 255.865 72.2415 242.918 67.9449C234.399 65.1175 222.432 62.4841 213.897 61.5592C209.125 61.042 189.231 60.9011 185.57 61.3588ZM181.583 123.489C176.112 124.724 173.171 125.802 167.763 128.558C154.82 135.152 144.631 147.257 140.622 160.801C140.094 162.584 139.703 163.06 138.768 163.06C136.519 163.06 128.19 165.785 124.46 167.74C112.799 173.854 104.017 185.736 101.815 198.381C100.873 203.787 101.436 214.486 102.906 219.14C107.486 233.641 118.666 244.449 133.542 248.758L137.729 249.971H194.341H250.953L255.631 248.779C270.077 245.096 281.589 235.675 287.948 222.33C291.925 213.984 292.41 211.628 292.387 200.801C292.367 192.045 292.278 191.233 290.866 186.981C284.037 166.418 267.069 153.27 245.959 152.186L241.017 151.932L239.225 148.955C231.944 136.866 221.243 128.664 207.25 124.451C203.175 123.224 201.462 123.023 193.809 122.877C187.492 122.756 184.072 122.927 181.583 123.489ZM188.618 144.569C176.051 145.841 164.426 156.028 161.139 168.647C160.687 170.384 160.081 174.898 159.794 178.678C159.506 182.458 159.149 185.672 159 185.82C158.852 185.969 155.42 185.668 151.375 185.151C145.331 184.378 143.487 184.321 141.024 184.833C131.731 186.762 124.419 194.324 123.236 203.228C121.725 214.599 129.098 225.324 140.183 227.879C143.606 228.669 245.487 228.634 249.199 227.842C258.163 225.93 265.515 219.734 269.302 210.901C271.01 206.917 271.404 198.612 270.1 194.093C267.044 183.507 258.111 175.688 247.38 174.206C242.839 173.579 240.056 173.923 231.816 176.129C229.185 176.834 226.981 177.41 226.917 177.411C226.855 177.412 225.932 174.602 224.867 171.167C222.334 162.992 219.87 158.37 215.901 154.342C208.484 146.814 199.22 143.496 188.618 144.569ZM314.778 152.219C309.536 154.096 305.18 155.7 305.097 155.782C305.014 155.865 305.662 158.314 306.537 161.224C309.998 172.743 311.333 182.19 311.327 195.149C311.321 207.585 309.861 217.607 306.439 228.691C292.65 273.361 255.444 304.543 208.427 310.831C202.945 311.565 186.8 311.565 181.318 310.831C162.999 308.381 146.462 302.383 131.376 292.718L128.161 290.658L140.254 290.647L152.347 290.636V280.004V269.373H120.454H88.5597V301.267V333.161H99.191H109.822V318.744C109.822 304.728 109.85 304.347 110.822 305.056C130.755 319.599 150.68 328.021 174.407 331.931C182.801 333.315 206.856 333.312 215.604 331.927C245.459 327.199 271.573 313.941 292.694 292.787C313.854 271.595 326.963 245.841 331.806 215.951C333.146 207.684 333.42 187.295 332.311 178.412C330.857 166.764 326.317 148.635 324.884 148.758C324.567 148.785 320.02 150.342 314.778 152.219Z",
    fill: "url(#paint0_linear_657_15)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_657_15",
    x: 61,
    y: 61,
    width: 272,
    height: 276.161,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_657_15"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_657_15",
    x1: 300.47,
    y1: 61,
    x2: 91.8309,
    y2: 333.161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AF598"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#02A1F9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyncUsuario);
export default __webpack_public_path__ + "static/media/SyncUsuario.ccae2641.svg";
export { ForwardRef as ReactComponent };